import axios from "axios";
import store from "@/store";

import { axiosInstance, risingInstance, risingAPI } from "./baseApi";
const authUrl = process.env.VUE_APP_BOT_URL;

export async function getCookie() {
  try {
    const res = await axiosInstance.get("auth");
    let result = res.data;
    axiosInstance.defaults.headers["SECRET-KEY"] = result.secret;
    axiosInstance.defaults.headers["Content-Type"] = "application/json";
    if (!axiosInstance.defaults.params) {
      axiosInstance.defaults.params = {};
    }

    store.commit("setAcess", result.cookie);
    console.log("store.state", store.state.acess);
    // const get_txn = await getRisingUserInfo();
    // console.log('get_txn',get_txn);
    // const txn_no = get_txn.data.auto?.txn_no;
    // axiosInstance.defaults.params['txn_no'] = txn_no
    const userInfo = await getUserInfo();
    // const botInfo = await getBotInfo();
    // return {...userInfo,cookie:result.cookie};
    return { user: { ...userInfo } };
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getUserInfo() {
  try {
    const res = await axiosInstance.get(`${authUrl}/user/login`);
    // console.log('data',res.data);
    let result = res.data.result;
    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getBotInfo() {
  try {
    const res = await axiosInstance.get(`${authUrl}/user/view`, {
      exchange: 1,
    });
    // console.log('data',res.data);
    let result = res.data.result;
    return result;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getRisingToken() {
  try {
    let res = await risingInstance.get("rising-token");
    let result = res.data;
    // risingInstance.defaults.headers['Cookie'] = `RID_AUT=${result.session_id}`;
    // risingInstance.defaults.headers['session_id'] = result.session_id;
    return result;
  } catch (error) {
    console.log("get rising token error", error);
    throw error;
  }
}

export async function getRisingUserInfo() {
  try {
    let res = await risingAPI.get(`/user/info`, {});

    let result = res.data;
    return result;
  } catch (error) {
    console.log("get rising token error", error);
    throw error;
  }
}
